import type { Speaker } from "./types";
interface SpeakerCardProps {
  speaker: Speaker;
  onClick: () => void;
}
export const SpeakerCard = ({
  speaker,
  onClick
}: SpeakerCardProps) => {
  return (
    <button
      onClick={onClick}
      className="text-center p-6 border rounded-lg hover:border-blue-200 transition-all bg-white group"
    >
      <div className="space-y-3">
        {/* Circular image container with blurred background */}
        <div className="w-32 h-32 mx-auto rounded-full overflow-hidden bg-gray-100 relative">
          {/* Blurred background image that fills the container */}
          <div className="absolute inset-0 overflow-hidden">
            <img
              src={speaker.image.mediumUrl}
              alt=""
              className="w-full h-full object-cover blur-xl scale-110 opacity-90"
              aria-hidden="true"
            />
            <div className="absolute inset-0 bg-black/10" />
          </div>

          {/* Main image - centered and contained within the container */}
          <div className="relative h-full w-full flex items-center justify-center">
            <img
              src={speaker.image.mediumUrl}
              alt={speaker.name}
              className="w-full h-full object-contain"
              onError={(e) => {
                e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(speaker.name)}&size=200`;
              }}
            />
          </div>
        </div>

        {/* Speaker info */}
        <div className="space-y-1">
          <h3 className="font-medium text-lg group-hover:text-blue-600 transition-colors">
            {speaker.name}
          </h3>
          {speaker.title && (
            <p className="text-gray-600 text-sm">{speaker.title}</p>
          )}
          {speaker.company && (
            <p className="text-gray-500 text-sm">{speaker.company}</p>
          )}
        </div>

        {/* Featured/Keynote badge */}
        {(speaker.featured || speaker.speakerType === 'keynote') && (
          <div className="flex justify-center">
            {speaker.speakerType === 'keynote' && (
              <span className="inline-flex items-center px-2.5 py-1 bg-yellow-50 text-yellow-700 rounded-full text-xs font-medium border border-yellow-200">
                Keynote Speaker
              </span>
            )}
            {speaker.featured && speaker.speakerType !== 'keynote' && (
              <span className="inline-flex items-center px-2.5 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium border border-blue-200">
                Featured
              </span>
            )}
          </div>
        )}

        {/* Topics - more subtle presentation */}
        {speaker.topics.length > 0 && (
          <div className="flex flex-wrap justify-center gap-1.5">
            {speaker.topics.slice(0, 2).map(topic => (
              <span
                key={topic}
                className="px-2 py-0.5 bg-gray-100 rounded-full text-xs text-gray-600"
              >
                {topic}
              </span>
            ))}
            {speaker.topics.length > 2 && (
              <span className="px-2 py-0.5 bg-gray-100 rounded-full text-xs text-gray-600">
                +{speaker.topics.length - 2}
              </span>
            )}
          </div>
        )}
      </div>
    </button>
  );
};
